import React from 'react';
import PropTypes from 'prop-types';
import StyledComponent from '~/components/Styled/Styled';
import logEvent from '~/util/analytics';
import css from './Follow.scss';

class Follow extends React.Component {
  static handleClick() {
    logEvent('conversion', {
      campaign: 'thescoreapp',
      type: 'follow_player_tooltip',
    });
  }

  constructor() {
    super();

    this.state = {
      tooltipOpen: false,
    };

    this.toggleTooltip = this.toggleTooltip.bind(this);
  }

  toggleTooltip() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    return (
      <div className={css.container}>
        <div
          className={css.followContainer}
          tabIndex="0"
          role="button"
          onClick={this.toggleTooltip}
        >
          {this.props.showText && 'Follow'} <img src="/static/images/follow.png" alt="" />
        </div>
        <div className={this.state.tooltipOpen ? '' : css.hideTooltip}>
          <div className={css.tooltip}>
            <div className={css.toolTipContainer}>
              <div className={css.toolTipImage} />
              <div tabIndex="0" role="button" className={css.closeX} onClick={this.toggleTooltip}>
                ✕
              </div>
              <div className={css.copyBox}>
                <div>Follow this player</div>
                <div className={css.smallCopyBox}>
                  Get the latest news, scores and stats on theScore app
                </div>
                <a href="https://thescore.app.link/MG25FMY27H">
                  <button className={css.getTheAppButton} onClick={Follow.handleClick}>
                    Get the App
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Follow.propTypes = {
  showText: PropTypes.bool,
};

Follow.defaultProps = {
  showText: true,
};

Follow.displayName = 'Follow';

export default StyledComponent(Follow, [css]);
